import { Component, OnDestroy, OnInit } from "@angular/core";
import { AppService }                   from "../../../services/app.service";
import { StatusListener }               from "../../../status-listener";

@Component({
	selector: "app-tur-update",
	templateUrl: "./tur-update.component.html",
	styleUrls: ["./tur-update.component.scss"]
})
export class TurUpdateComponent extends StatusListener implements OnInit, OnDestroy {

	private timer = 0;

	constructor(app: AppService) {
		super(app);
	}

	ngOnInit() {
		// After 10 seconds, check each second if the Device is available
		// again. If so, open the initializing page. The navigator service will
		// take us to the next page (dependent on VMC state, like menu or intervention page).
		window.setTimeout(() => {
			this.timer = window.setInterval(async () => {
				if ("pong" === await this.app.api.systemApi.ping()) {
					this.app.nav.leaveUpdatePage();
				}
			}, 1000);
		}, 10000);
	}

	ngOnDestroy() {
		if (this.timer)
			window.clearInterval(this.timer);
	}

}
